import React, { useEffect, useState } from "react";
import { v4 } from "uuid";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  TextField
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { ONLY_NUMBERS_REGEXP } from "common/regExp";
import { EMPTY_STRING } from "common/constants";

import useStyles from "./styles";

const MAX_LENGTH_HORSE_NAME_FIELD = 18;

export type UnlistedHorse = {
  id: string;
  name: string;
  registrationNumber: string;
};

interface IProps {
  setIsOpenEntryModal: (param: boolean) => void;
  searchQuery: string;
  onAddHorseClick: (horse: UnlistedHorse) => void;
}

const AddUnlistedHorsePopup = (props: IProps) => {
  const { setIsOpenEntryModal, searchQuery, onAddHorseClick } = props;

  const [horseName, setHorseName] = useState("");
  const [horseRegistrationNumber, setHorseRegistrationNumber] = useState("");

  const classes = useStyles();

  const handleAddEntryDialogClose = () => {
    setIsOpenEntryModal(false);
  };

  const handleNameChange = event => {
    const value = event.target.value.replace(/ +/g, " ");
    setHorseName(value);
  };

  const handleIDChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (ONLY_NUMBERS_REGEXP.test(value) || value === EMPTY_STRING) {
      setHorseRegistrationNumber(value);
    }
  };

  const handleAddHorseClick = () => {
    const horse = {
      id: v4(),
      name: horseName.trim(),
      registrationNumber: horseRegistrationNumber
    };
    onAddHorseClick(horse);
  };

  const handleAddHorseCancelClick = () => {
    setIsOpenEntryModal(false);
  };

  useEffect(() => {
    setHorseName(
      searchQuery
        .trim()
        .replace(/ +/g, " ")
        .substring(0, MAX_LENGTH_HORSE_NAME_FIELD)
    );
    setHorseRegistrationNumber("");
  }, []);

  return (
    <Dialog
      classes={{
        paper: classes.addEntryDialogPaper
      }}
      open={true}
      onClose={handleAddEntryDialogClose}
    >
      <DialogTitle className={classes.addEntryDialogTitle}>
        Add Unlisted Horse
        <IconButton
          color="primary"
          onClick={handleAddEntryDialogClose}
          size={"small"}
          classes={{
            root: classes.addEntryDialogCloseButton
          }}
        >
          <CloseIcon className={classes.addEntryDialogCloseButtonIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.addEntryDialogContent}>
        <span>
          If you were unable to find your horse, fill out the information below
          to create your stable entry.
        </span>
        <FormControl
          className={classes.addEntryDialogFormControl}
          variant={"outlined"}
        >
          <InputLabel
            className={classes.addEntryDialogInputLabel}
            disableAnimation
          >
            Horse Name
          </InputLabel>
          <TextField
            InputProps={{
              classes: {
                input: classes.addEntryDialogInput
              }
            }}
            autoFocus
            inputProps={{ maxLength: MAX_LENGTH_HORSE_NAME_FIELD }}
            value={horseName}
            onChange={handleNameChange}
            variant="outlined"
          />
        </FormControl>
        <FormControl
          className={classes.addEntryDialogFormControl}
          variant={"outlined"}
        >
          <InputLabel
            className={classes.addEntryDialogInputLabel}
            disableAnimation
          >
            Horse Registration Number
          </InputLabel>
          <TextField
            InputProps={{
              classes: {
                input: classes.addEntryDialogInput
              }
            }}
            inputProps={{ maxLength: 12 }}
            placeholder={"e.g. 12345678"}
            value={horseRegistrationNumber}
            onChange={handleIDChange}
            variant="outlined"
          />
        </FormControl>
        <div className={classes.addEntryDialogButtons}>
          <Button onClick={handleAddHorseCancelClick}>CANCEL</Button>
          <Button
            className={classes.addEntryDialogButtonsAdd}
            disabled={!horseName.trim()}
            onClick={handleAddHorseClick}
          >
            ADD HORSE
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddUnlistedHorsePopup;
